export const UploadDocumentsConstants = {
  PHOTOGRAPH_LI: { tabName: "PHOTOGRAPH_LI", route: "/uploaddoc/photograph_li" },
  PHOTOGRAPH_PROPOSER: { tabName: "PHOTOGRAPH_PROPOSER", route: "/uploaddoc/photograph_proposer" },
  PHOTO_ID_LI: { tabName: "PHOTO_ID_LI", route: "/uploaddoc/photo_id_li" },
  PHOTO_ID_PROPOSER: { tabName: "PHOTO_ID_PROPOSER", route: "/uploaddoc/photo_id_proposer" },
  ADDRESS_PROOF_LI: { tabName: "ADDRESS_PROOF_LI", route: "/uploaddoc/address_proof_li" },
  ADDRESS_PROOF_PROPOSER: { tabName: "ADDRESS_PROOF_PROPOSER", route: "/uploaddoc/address_proof_proposer" },
  PIO_CARD_LI: { tabName: "PIO_CARD_LI", route: "/uploaddoc/pio_card_li" },
  PIO_CARD_PROPOSER: { tabName: "PIO_CARD_PROPOSER", route: "/uploaddoc/pio_card_proposer" },
  PASSPORT_LI: { tabName: "PASSPORT_LI", route: "/uploaddoc/passport_li" },
  PASSPORT_PROPOSER: { tabName: "PASSPORT_PROPOSER", route: "/uploaddoc/passport_proposer" },
  OWNER_BANK_PROOF: { tabName: "OWNER_BANK_PROOF", route: "/uploaddoc/bankproof" },
};

export const calculateAgeInInt = (dob) => {
  if (dob) {
    const [day, month, year] = dob.split("/").map(Number); // Adjust to parse day, month, year

    // Create a new Date object using the corrected parsed parts
    const birthDate = new Date(year, month - 1, day); // month - 1 because months are 0-indexed in JavaScript

    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    // Adjust age if the birth date hasn't occurred yet this year
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  } else {
    return null;
  }
};

export const hanldeNextFromUtility = (tabName, LeadData, SameProposer, isLastTab) => {
  let selectedLifeInsured = LeadData?.lifeInsuredDetails[0];
  // LeadData?.lifeInsuredDetails?.filter((item) => {
  //   if (item?.selectedLi == true) {
  //     selectedLifeInsured = item;
  //   }
  // });
  console.log("slected LI=====>", selectedLifeInsured)

  // Always show Life Insured's document first for any document type
  // This ensures that when navigating to a document type, we first show Life Insured's document
  // regardless of whether data is uploaded or not
  const lifeInsuredDocumentMap = {
    PHOTOGRAPH: UploadDocumentsConstants.PHOTOGRAPH_LI.route,
    PHOTO_ID: UploadDocumentsConstants.PHOTO_ID_LI.route,
    ADDRESS_PROOF: UploadDocumentsConstants.ADDRESS_PROOF_LI.route,
    PIO_CARD: UploadDocumentsConstants.PIO_CARD_LI.route,
    PASSPORT: UploadDocumentsConstants.PASSPORT_LI.route,
  };

  // Check if the current tab navigation should start with Life Insured document
  // This applies to any document type regardless of upload status
  const currentDocumentType = Object.keys(lifeInsuredDocumentMap).find(type => {
    // Check if tabName contains any document type keywords
    return tabName.includes(type) || tabName === type;
  });
  
  // For initial navigation to any document type, always show Life Insured first
  if (currentDocumentType && !tabName.includes('_LI') && !tabName.includes('_PROPOSER')) {
    return lifeInsuredDocumentMap[currentDocumentType];
  }

  const age_li = calculateAgeInInt(selectedLifeInsured?.dob);
  const age_proposer = calculateAgeInInt(LeadData?.dobProposer);

  let routeToReturn = null;

  switch (tabName) {
    case UploadDocumentsConstants.PHOTOGRAPH_LI.tabName:
      routeToReturn =
        SameProposer === false
          ? UploadDocumentsConstants.PHOTOGRAPH_PROPOSER.route
          : selectedLifeInsured?.WOEKYCStatus === true
          ? UploadDocumentsConstants.PHOTO_ID_LI.route
          : LeadData?.WOEKYCStatus === true
          ? UploadDocumentsConstants.PHOTO_ID_PROPOSER.route
          : selectedLifeInsured?.lifeInsuredResidentialStatus === "PIO"
          ? UploadDocumentsConstants.PIO_CARD_LI.route
          : LeadData?.proposerResidentialStatus === "PIO"
          ? UploadDocumentsConstants.PIO_CARD_PROPOSER.route
          : selectedLifeInsured?.lifeInsuredResidentialStatus !== "Indian"
          ? UploadDocumentsConstants.PASSPORT_LI.route
          : LeadData?.proposerResidentialStatus !== "Indian";
      // ? UploadDocumentsConstants.PASSPORT_PROPOSER?.route
      // : UploadDocumentsConstants.OWNER_BANK_PROOF.route;
      break;

    case UploadDocumentsConstants.PHOTOGRAPH_PROPOSER.tabName:
      routeToReturn =
        selectedLifeInsured?.WOEKYCStatus === true
          ? UploadDocumentsConstants.PHOTO_ID_LI.route
          : LeadData?.WOEKYCStatus === true
          ? UploadDocumentsConstants.PHOTO_ID_PROPOSER.route
          : selectedLifeInsured?.lifeInsuredResidentialStatus === "PIO"
          ? UploadDocumentsConstants.PIO_CARD_LI.route
          : LeadData?.proposerResidentialStatus === "PIO"
          ? UploadDocumentsConstants.PIO_CARD_PROPOSER.route
          : selectedLifeInsured?.lifeInsuredResidentialStatus !== "Indian"
          ? UploadDocumentsConstants.PASSPORT_LI.route
          : LeadData?.proposerResidentialStatus !== "Indian";
      // ? UploadDocumentsConstants.PASSPORT_PROPOSER?.route
      // : UploadDocumentsConstants.OWNER_BANK_PROOF.route;
      break;

    case UploadDocumentsConstants.PHOTO_ID_LI.tabName:
      routeToReturn =
        SameProposer === false
          ? LeadData?.WOEKYCStatus === true
            ? UploadDocumentsConstants.PHOTO_ID_PROPOSER.route
            : selectedLifeInsured?.WOEKYCStatus === true && age_li > 17
            ? UploadDocumentsConstants.ADDRESS_PROOF_LI.route
            : LeadData?.WOEKYCStatus === true && age_proposer > 17
            ? UploadDocumentsConstants.ADDRESS_PROOF_PROPOSER.route
            : selectedLifeInsured?.lifeInsuredResidentialStatus === "PIO"
            ? UploadDocumentsConstants.PIO_CARD_LI.route
            : LeadData?.proposerResidentialStatus === "PIO"
            ? UploadDocumentsConstants.PIO_CARD_PROPOSER.route
            : selectedLifeInsured?.lifeInsuredResidentialStatus !== "Indian"
            ? UploadDocumentsConstants.PASSPORT_LI.route
            : LeadData?.proposerResidentialStatus !== "Indian"
          : // ? UploadDocumentsConstants.PASSPORT_PROPOSER.route
          // : UploadDocumentsConstants.OWNER_BANK_PROOF.route
          selectedLifeInsured?.WOEKYCStatus === true && age_li > 17
          ? UploadDocumentsConstants.ADDRESS_PROOF_LI.route
          : LeadData?.WOEKYCStatus === true && age_proposer > 17
          ? UploadDocumentsConstants.ADDRESS_PROOF_PROPOSER.route
          : selectedLifeInsured?.lifeInsuredResidentialStatus === "PIO"
          ? UploadDocumentsConstants.PIO_CARD_LI.route
          : LeadData?.proposerResidentialStatus === "PIO"
          ? UploadDocumentsConstants.PIO_CARD_PROPOSER.route
          : selectedLifeInsured?.lifeInsuredResidentialStatus !== "Indian"
          ? UploadDocumentsConstants.PASSPORT_LI.route
          : LeadData?.proposerResidentialStatus !== "Indian";
      // ? UploadDocumentsConstants.PASSPORT_PROPOSER.route
      // : UploadDocumentsConstants.OWNER_BANK_PROOF.route;

      break;

    case UploadDocumentsConstants.PHOTO_ID_PROPOSER.tabName:
      routeToReturn =
        selectedLifeInsured?.WOEKYCStatus === true && age_li > 17
          ? UploadDocumentsConstants.ADDRESS_PROOF_LI.route
          : LeadData?.WOEKYCStatus === true && age_proposer > 17
          ? UploadDocumentsConstants.ADDRESS_PROOF_PROPOSER.route
          : selectedLifeInsured?.lifeInsuredResidentialStatus === "PIO"
          ? UploadDocumentsConstants.PIO_CARD_LI.route
          : LeadData?.proposerResidentialStatus === "PIO"
          ? UploadDocumentsConstants.PIO_CARD_PROPOSER.route
          : selectedLifeInsured?.lifeInsuredResidentialStatus !== "Indian"
          ? UploadDocumentsConstants.PASSPORT_LI.route
          : LeadData?.proposerResidentialStatus !== "Indian";
      // ? UploadDocumentsConstants.PASSPORT_PROPOSER.route
      // : UploadDocumentsConstants.OWNER_BANK_PROOF.route;
      break;

    case UploadDocumentsConstants.ADDRESS_PROOF_LI.tabName:
      routeToReturn =
        SameProposer === false
          ? LeadData?.WOEKYCStatus === true && age_proposer > 17
            ? UploadDocumentsConstants.ADDRESS_PROOF_PROPOSER.route
            : selectedLifeInsured?.lifeInsuredResidentialStatus === "PIO"
            ? UploadDocumentsConstants.PIO_CARD_LI.route
            : LeadData?.proposerResidentialStatus === "PIO"
            ? UploadDocumentsConstants.PIO_CARD_PROPOSER.route
            : selectedLifeInsured.lifeInsuredResidentialStatus !== "Indian"
            ? UploadDocumentsConstants.PASSPORT_LI.route
            : LeadData?.proposerResidentialStatus !== "Indian"
          : // ? UploadDocumentsConstants.PASSPORT_PROPOSER.route
          // : UploadDocumentsConstants.OWNER_BANK_PROOF.route
          selectedLifeInsured?.lifeInsuredResidentialStatus === "PIO"
          ? UploadDocumentsConstants.PIO_CARD_LI.route
          : LeadData?.proposerResidentialStatus === "PIO"
          ? UploadDocumentsConstants.PIO_CARD_PROPOSER.route
          : selectedLifeInsured.lifeInsuredResidentialStatus !== "Indian"
          ? UploadDocumentsConstants.PASSPORT_LI.route
          : LeadData?.proposerResidentialStatus !== "Indian";
      // ? UploadDocumentsConstants.PASSPORT_PROPOSER.route
      // : UploadDocumentsConstants.OWNER_BANK_PROOF.route;
      break;

    case UploadDocumentsConstants.ADDRESS_PROOF_PROPOSER.tabName:
      routeToReturn =
        selectedLifeInsured?.lifeInsuredResidentialStatus === "PIO"
          ? UploadDocumentsConstants.PIO_CARD_LI.route
          : LeadData?.proposerResidentialStatus === "PIO"
          ? UploadDocumentsConstants.PIO_CARD_PROPOSER.route
          : selectedLifeInsured.lifeInsuredResidentialStatus !== "Indian"
          ? UploadDocumentsConstants.PASSPORT_LI.route
          : LeadData?.proposerResidentialStatus !== "Indian"
      ? UploadDocumentsConstants.PASSPORT_PROPOSER.route
      : UploadDocumentsConstants.OWNER_BANK_PROOF.route;
      break;

    case UploadDocumentsConstants.PIO_CARD_LI.tabName:
      routeToReturn =
        SameProposer === false
          ? LeadData?.proposerResidentialStatus === "PIO"
            ? UploadDocumentsConstants.PIO_CARD_PROPOSER.route
            : selectedLifeInsured.lifeInsuredResidentialStatus !== "Indian"
            ? UploadDocumentsConstants.PASSPORT_LI.route
            : LeadData?.proposerResidentialStatus !== "Indian"
          : // ? UploadDocumentsConstants.PASSPORT_PROPOSER.route
          // : UploadDocumentsConstants.OWNER_BANK_PROOF.route
          selectedLifeInsured.lifeInsuredResidentialStatus !== "Indian"
          ? UploadDocumentsConstants.PASSPORT_LI.route
          : LeadData?.proposerResidentialStatus !== "Indian";
      // ? UploadDocumentsConstants.PASSPORT_PROPOSER.route
      // : UploadDocumentsConstants.OWNER_BANK_PROOF.route;
      break;

    case UploadDocumentsConstants.PIO_CARD_PROPOSER.tabName:
      routeToReturn = selectedLifeInsured.lifeInsuredResidentialStatus !== "Indian" ? UploadDocumentsConstants.PASSPORT_LI.route 
      : LeadData?.proposerResidentialStatus !== "Indian"
      ? UploadDocumentsConstants.PASSPORT_PROPOSER.route
      : UploadDocumentsConstants.OWNER_BANK_PROOF.route;
      break;

    case UploadDocumentsConstants.PASSPORT_LI.tabName:
      routeToReturn = SameProposer === false 
      ? (LeadData?.proposerResidentialStatus !== "Indian" 
      ? UploadDocumentsConstants.PASSPORT_PROPOSER.route 
      : UploadDocumentsConstants.OWNER_BANK_PROOF.route) 
      : UploadDocumentsConstants.OWNER_BANK_PROOF.route;
      break;

    // case UploadDocumentsConstants.PASSPORT_PROPOSER.tabName:
    //   routeToReturn = UploadDocumentsConstants.OWNER_BANK_PROOF.route;
    // break;
  }
  // console.log("redirectPath next", routeToReturn);
  return routeToReturn;
};

export const hanldePreviousFromUtility = (tabName, LeadData, SameProposer) => {
  let selectedLifeInsured = LeadData?.lifeInsuredDetails[0];
  // LeadData?.lifeInsuredDetails?.filter((item) => {
  //   if (item?.selectedLi == true) {
  //     selectedLifeInsured = item;
  //   }
  // });

  const age_li = calculateAgeInInt(selectedLifeInsured?.dob);
  const age_proposer = calculateAgeInInt(LeadData?.dobProposer);

  let routeToReturn = null;

  switch (tabName) {
    case UploadDocumentsConstants.PHOTOGRAPH_PROPOSER.tabName:
      routeToReturn = UploadDocumentsConstants.PHOTOGRAPH_LI.route;
      break;

    case UploadDocumentsConstants.PHOTO_ID_LI.tabName:
      routeToReturn = UploadDocumentsConstants.PHOTOGRAPH_LI.route;
      break;

    case UploadDocumentsConstants.PHOTO_ID_PROPOSER.tabName:
      routeToReturn = selectedLifeInsured?.WOEKYCStatus === true ? UploadDocumentsConstants.PHOTO_ID_LI.route : UploadDocumentsConstants.PHOTOGRAPH_LI.route;
      break;

    case UploadDocumentsConstants.ADDRESS_PROOF_LI.tabName:
      routeToReturn =
        selectedLifeInsured?.WOEKYCStatus === true
          ? UploadDocumentsConstants.PHOTO_ID_LI.route
          : LeadData?.WOEKYCStatus === true
          ? UploadDocumentsConstants.PHOTO_ID_PROPOSER.route
          : SameProposer === true
          ? UploadDocumentsConstants.PHOTOGRAPH_LI.route
          : UploadDocumentsConstants.PHOTO_ID_PROPOSER.route;
      break;

    case UploadDocumentsConstants.ADDRESS_PROOF_PROPOSER.tabName:
      routeToReturn =
        SameProposer === false
          ? selectedLifeInsured?.WOEKYCStatus === true && age_li > 17
            ? UploadDocumentsConstants.ADDRESS_PROOF_LI.route
            : LeadData?.WOEKYCStatus === true
            ? UploadDocumentsConstants.PHOTO_ID_PROPOSER.route
            : selectedLifeInsured?.WOEKYCStatus === true
            ? UploadDocumentsConstants.PHOTO_ID_LI.route
            : SameProposer === false
            ? UploadDocumentsConstants.PHOTOGRAPH_PROPOSER.route
            : UploadDocumentsConstants.PHOTOGRAPH_LI.route
          : LeadData?.WOEKYCStatus === true
          ? UploadDocumentsConstants.PHOTO_ID_PROPOSER.route
          : selectedLifeInsured?.WOEKYCStatus === true
          ? UploadDocumentsConstants.PHOTO_ID_LI.route
          : SameProposer === false
          ? UploadDocumentsConstants.PHOTOGRAPH_PROPOSER.route
          : UploadDocumentsConstants.PHOTOGRAPH_LI.route;
      break;

    case UploadDocumentsConstants.PIO_CARD_LI.tabName:
      routeToReturn =
        LeadData?.WOEKYCStatus === true && age_proposer > 17
          ? UploadDocumentsConstants.ADDRESS_PROOF_PROPOSER.route
          : selectedLifeInsured?.WOEKYCStatus === true && age_li > 17
          ? UploadDocumentsConstants.ADDRESS_PROOF_LI.route
          : LeadData?.WOEKYCStatus === true
          ? UploadDocumentsConstants.PHOTO_ID_PROPOSER.route
          : selectedLifeInsured?.WOEKYCStatus === true
          ? UploadDocumentsConstants.PHOTO_ID_LI.route
          : SameProposer === true
          ? UploadDocumentsConstants.PHOTOGRAPH_LI.route
          : UploadDocumentsConstants.PHOTOGRAPH_PROPOSER.route;
      break;

    case UploadDocumentsConstants.PIO_CARD_PROPOSER.tabName:
      routeToReturn =
        selectedLifeInsured?.lifeInsuredResidentialStatus === "PIO"
          ? UploadDocumentsConstants.PIO_CARD_LI.route
          : LeadData?.WOEKYCStatus === true && age_proposer > 17
          ? UploadDocumentsConstants.ADDRESS_PROOF_PROPOSER.route
          : selectedLifeInsured?.WOEKYCStatus === true && age_li > 17
          ? UploadDocumentsConstants.ADDRESS_PROOF_LI.route
          : LeadData?.WOEKYCStatus === true
          ? UploadDocumentsConstants.PHOTO_ID_PROPOSER.route
          : selectedLifeInsured?.WOEKYCStatus === true
          ? UploadDocumentsConstants.PHOTO_ID_LI.route
          : SameProposer === true
          ? UploadDocumentsConstants.PHOTOGRAPH_LI.route
          : UploadDocumentsConstants.PHOTOGRAPH_PROPOSER.route;
      break;

    case UploadDocumentsConstants.PASSPORT_LI.tabName:
      routeToReturn =
        LeadData?.proposerResidentialStatus === "PIO"
          ? UploadDocumentsConstants.PIO_CARD_PROPOSER.route
          : selectedLifeInsured?.lifeInsuredResidentialStatus === "PIO"
          ? UploadDocumentsConstants.PIO_CARD_LI.route
          : LeadData?.WOEKYCStatus === true && age_proposer > 17
          ? UploadDocumentsConstants.ADDRESS_PROOF_PROPOSER.route
          : selectedLifeInsured?.WOEKYCStatus === true && age_li > 17
          ? UploadDocumentsConstants.ADDRESS_PROOF_LI.route
          : LeadData?.WOEKYCStatus === true
          ? UploadDocumentsConstants.PHOTO_ID_PROPOSER.route
          : selectedLifeInsured?.WOEKYCStatus === true
          ? UploadDocumentsConstants.PHOTO_ID_LI.route
          : SameProposer === true
          ? UploadDocumentsConstants.PHOTOGRAPH_LI.route
          : UploadDocumentsConstants.PHOTOGRAPH_PROPOSER.route;

      break;

    case UploadDocumentsConstants.PASSPORT_PROPOSER.tabName:
      routeToReturn =
        selectedLifeInsured?.lifeInsuredResidentialStatus !== "Indian"
          ? UploadDocumentsConstants.PASSPORT_LI.route
          : LeadData?.proposerResidentialStatus === "PIO"
          ? UploadDocumentsConstants.PIO_CARD_PROPOSER.route
          : selectedLifeInsured?.lifeInsuredResidentialStatus === "PIO"
          ? UploadDocumentsConstants.PIO_CARD_LI.route
          : LeadData?.WOEKYCStatus === true && age_proposer > 17
          ? UploadDocumentsConstants.ADDRESS_PROOF_PROPOSER.route
          : selectedLifeInsured?.WOEKYCStatus === true && age_li > 17
          ? UploadDocumentsConstants.ADDRESS_PROOF_LI.route
          : LeadData?.WOEKYCStatus === true
          ? UploadDocumentsConstants.PHOTO_ID_PROPOSER.route
          : selectedLifeInsured?.WOEKYCStatus === true
          ? UploadDocumentsConstants.PHOTO_ID_LI.route
          : SameProposer === true
          ? UploadDocumentsConstants.PHOTOGRAPH_LI.route
          : UploadDocumentsConstants.PHOTOGRAPH_PROPOSER.route;
      break;

    case UploadDocumentsConstants.OWNER_BANK_PROOF.tabName:
      routeToReturn =
        LeadData?.proposerResidentialStatus !== "Indian"
          ? UploadDocumentsConstants.PASSPORT_PROPOSER.route
          : selectedLifeInsured?.lifeInsuredResidentialStatus !== "Indian"
          ? UploadDocumentsConstants.PASSPORT_LI.route
          : LeadData?.proposerResidentialStatus === "PIO"
          ? UploadDocumentsConstants.PIO_CARD_PROPOSER.route
          : selectedLifeInsured?.lifeInsuredResidentialStatus === "PIO"
          ? UploadDocumentsConstants.PIO_CARD_LI.route
          : LeadData?.WOEKYCStatus === true && age_proposer > 17
          ? UploadDocumentsConstants.ADDRESS_PROOF_PROPOSER.route
          : selectedLifeInsured?.WOEKYCStatus === true && age_li > 17
          ? UploadDocumentsConstants.ADDRESS_PROOF_LI.route
          : LeadData?.WOEKYCStatus === true
          ? UploadDocumentsConstants.PHOTO_ID_PROPOSER.route
          : selectedLifeInsured?.WOEKYCStatus === true
          ? UploadDocumentsConstants.PHOTO_ID_LI.route
          : SameProposer === true
          ? UploadDocumentsConstants.PHOTOGRAPH_LI.route
          : UploadDocumentsConstants.PHOTOGRAPH_PROPOSER.route;
      break;
  }

  // console.log("redirectPath back", routeToReturn);
  return routeToReturn;
};

// Helper function to check if documents are uploaded for Life Insured for a specific document type
export const checkDocumentUploadedForLifeInsured = (documentUpload, documentType) => {
  if (!documentUpload || documentUpload.length === 0) {
    return false;
  }

  // Check if the document type exists and has uploaded documents
  return documentUpload.some(doc => {
    switch (documentType) {
      case 'PHOTOGRAPH':
        return doc.UploadPhoto_life_Insured && doc.UploadPhoto_life_Insured.length > 0;
      case 'PHOTO_ID':
        return doc.UploadPhoto_ID_life_Insured && doc.UploadPhoto_ID_life_Insured.length > 0;
      case 'ADDRESS_PROOF':
        return doc.UploadAddress_Proof_life_Insured && doc.UploadAddress_Proof_life_Insured.length > 0;
      default:
        return false;
    }
  });
};

// Helper function to check if documents are uploaded for Proposer for a specific document type
export const checkDocumentUploadedForProposer = (documentUpload, documentType) => {
  if (!documentUpload || documentUpload.length === 0) {
    return false;
  }

  // Check if the document type exists and has uploaded documents
  return documentUpload.some(doc => {
    switch (documentType) {
      case 'PHOTOGRAPH':
        return doc.UploadPhoto_Proposer && doc.UploadPhoto_Proposer.length > 0;
      case 'PHOTO_ID':
        return doc.UploadPhoto_ID_Proposer && doc.UploadPhoto_ID_Proposer.length > 0;
      case 'ADDRESS_PROOF':
        return doc.UploadAddress_Proof_Proposer && doc.UploadAddress_Proof_Proposer.length > 0;
      default:
        return false;
    }
  });
};

// Helper function to determine if Next button should be enabled for Life Insured view
export const shouldEnableNextButtonForLifeInsured = (documentUpload, currentDocumentType, isTeamView = false) => {
  if (!isTeamView) {
    // Original logic for non-team view - enable if current document is uploaded
    return checkDocumentUploadedForLifeInsured(documentUpload, currentDocumentType);
  }
  
  // Team view logic - enable only if Life Insured documents are uploaded
  return checkDocumentUploadedForLifeInsured(documentUpload, currentDocumentType);
};

// Helper function to determine if Previous button should be enabled for Proposer view
export const shouldEnablePreviousButtonForProposer = (documentUpload, currentDocumentType, isTeamView = false) => {
  if (!isTeamView) {
    // Original logic for non-team view - always enable previous
    return true;
  }
  
  // Team view logic - always enable previous to go back to Life Insured
  return true;
};

// New utility function to ensure Life Insured documents are always shown first
// regardless of upload status or view mode
export const getInitialDocumentRoute = (documentType) => {
  const lifeInsuredRoutes = {
    PHOTOGRAPH: UploadDocumentsConstants.PHOTOGRAPH_LI.route,
    PHOTO_ID: UploadDocumentsConstants.PHOTO_ID_LI.route,
    ADDRESS_PROOF: UploadDocumentsConstants.ADDRESS_PROOF_LI.route,
    PIO_CARD: UploadDocumentsConstants.PIO_CARD_LI.route,
    PASSPORT: UploadDocumentsConstants.PASSPORT_LI.route,
  };

  return lifeInsuredRoutes[documentType] || null;
};
